import api from './api'

const settingService = {
  // Dùng chung cho cả public landing lẫn admin (trả toàn bộ setting)
  async list() {
    const response = await api.get('/settings')
    return response.data
  },

  // Lưu nhiều value cùng lúc: values = { key: value, ... }
  async bulkUpdate(values) {
    const response = await api.put('/settings/bulk', { values })
    return response.data
  },

  async create(data) {
    const response = await api.post('/settings', data)
    return response.data
  },

  async update(id, data) {
    const response = await api.put(`/settings/${id}`, data)
    return response.data
  },

  async remove(id) {
    const response = await api.delete(`/settings/${id}`)
    return response.data
  },
}

// Chuyển list setting -> map { key: value } cho landing dùng nhanh
export const toMap = (items = []) =>
  items.reduce((acc, s) => { acc[s.key] = s.value; return acc }, {})

// Nhãn nhóm hiển thị ở admin
export const SETTING_GROUP_LABELS = {
  brand: 'Thương hiệu',
  hero: 'Khu vực Hero (đầu trang)',
  contact: 'Thông tin liên hệ',
  footer: 'Chân trang (CTA)',
  notify: 'Thông báo email',
  seo: 'SEO & chia sẻ mạng xã hội',
}

export default settingService
